import * as React from 'react';
import * as styles from './styles.css';

export interface IPlaceholderProps {
  hidePartText: string;
  visiblePartText: string;
}

export function Placeholder({ hidePartText, visiblePartText }: IPlaceholderProps) {
  return (
    <div className={styles['container']}>
      <span className={styles['hidden-part']}>{hidePartText}</span>
      <input className={styles['visible-part']} type="text" value={visiblePartText} readOnly />
    </div>
  );
}
